
import { Component, OnInit } from '@angular/core';
import { DataService, Drug, Filters } from '../data.service';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})
export class ResultsComponent implements OnInit {
  drugs: Drug[] = [];
  stats = {
    totalDrugs: 0,
    ndaCount: 0,
    sndaCount: 0,
    priorityReviews: 0
  };
  isEditMode = false;
  editItem: any = null;

  constructor(
    private dataService: DataService,
    private dashboardService: DashboardService
  ) {}

  ngOnInit() {
    this.dashboardService.filters$.subscribe(filters => {
      // this.loadResults(filters);
    });

    // Subscribe to edit mode
    this.dashboardService.editMode$.subscribe(editMode => {
      this.isEditMode = editMode;
    });

    this.dashboardService.editItem$.subscribe(item => {
      this.editItem = item;
      if (item && this.isEditMode) {
        // Open drug modal for editing
        this.dashboardService.openDrugModal();
      }
    });
  }

  addNewEntry() {
    // Clear all filters before opening the drug modal
    // this.dashboardService.resetFilters();
    // Navigate back to calendar step for fresh start
    // this.dashboardService.navigateToStep('calendar');
    this.dashboardService.openDrugModal();
  }

  exportData() {
    // Implement export functionality
    console.log('Export data functionality');
  }

  private loadResults(filters: Filters) {
    this.dashboardService.showLoading();

    setTimeout(() => {
      this.dataService.getFilteredDrugs(filters).subscribe(drugs => {
        this.drugs = drugs;
        this.updateStats();
        this.dashboardService.hideLoading();
      });
    }, 800);
  }

  private updateStats() {
    this.dataService.getStatistics(this.dashboardService.getFilters()).subscribe(stats => {
      this.stats = stats;
    });
  }
}
